import type { CustomRoleTaxonomySelection } from '@revelio/data-access';

export const getRoleTaxonomyId = (
  taxonomySelection: CustomRoleTaxonomySelection | undefined
) => {
  if (taxonomySelection === undefined) return undefined;

  if (
    taxonomySelection.taxonomyId !== undefined &&
    taxonomySelection.taxonomyId !== null
  ) {
    return taxonomySelection.taxonomyId;
  }

  if (taxonomySelection.default) {
    return 0;
  }

  if (taxonomySelection.ricsK10Id) {
    return Number(taxonomySelection.ricsK10Id) + 50;
  }

  if (taxonomySelection.ricsK50Id) {
    return Number(taxonomySelection.ricsK50Id);
  }

  return 0;
};
